var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAssinale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8A38ABA4-D356-4E53-9850-F5A957844115") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Maio---indique-um-amigo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "indique-v2-1",
    transform: "translate(-464.000000, -885.000000)",
    fill: "#FF6A58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-assinale",
    transform: "translate(464.000000, 885.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.10419285,6.67970851 C9.22848159,1.85429605 16.0354213,0.31635801 21.8336665,2.8999051 C22.338139,3.12468491 22.5648747,3.71586069 22.3400949,4.22033317 C22.1153151,4.72480565 21.5241393,4.95154137 21.0196668,4.72676156 C16.0304791,2.50370941 10.1733449,3.82705145 6.62453834,7.97915054 C3.07573175,12.1312496 2.68063733,18.1230069 5.65351144,22.7051434 C8.62638554,27.2872799 14.2590402,29.3682546 19.4969348,27.8195728 C24.6360012,26.3001113 28.193951,21.6418007 28.3293331,16.3084261 L28.3333333,16 L28.3333333,14.7733333 C28.3333333,14.2210486 28.7810486,13.7733333 29.3333333,13.7733333 C29.8461692,13.7733333 30.2688405,14.1593735 30.3266056,14.6567122 L30.3333333,14.7733333 L30.3333333,16.0005718 C30.3297037,22.3483548 26.1512878,27.937677 20.064005,29.7374965 C13.9767221,31.5373159 7.43066392,29.1188858 3.97570213,23.7937002 C0.520740331,18.4685146 0.979904109,11.505121 5.10419285,6.67970851 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6258733,4.62658002 C29.0162023,4.23586061 29.6493672,4.23554419 30.0400866,4.62587326 C30.4007507,4.98617703 30.4287637,5.55339416 30.1239349,5.94583775 L30.0407934,6.04008665 L16.7074601,19.3867533 C16.347029,19.7475448 15.7795698,19.7754329 15.3871346,19.470322 L15.2928932,19.3871068 L11.2928932,15.3871068 C10.9023689,14.9965825 10.9023689,14.3634175 11.2928932,13.9728932 C11.6533772,13.6124093 12.2206082,13.5846797 12.6128994,13.8897046 L12.7071068,13.9728932 L16,17.265 L28.6258733,4.62658002 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAssinale);
export default __webpack_public_path__ + "static/media/ic-assinale.2d3064d5680b3e4ed22dada10cead6ff.svg";
export { ForwardRef as ReactComponent };